import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RepeatContainer } from '../style';
import { Footer } from '../Footer';
import { RepeatWorkoutContent } from './Content/RepeatWorkoutContent';
import Countdown from './Content/Countdown';
import { Loading } from '../../WithLoading/Loading';
import { CountdownBackground } from './Content/style';
import { Text } from '../../../UI/Text';
import { BreakDownActionCreators } from '../../../../Store/ActionCreators/BreakdownActionCreators';
import { WorkoutActionCreators } from '../../../../Store/ActionCreators/WorkoutsActionCreators';

class RepeatWorkout extends Component {
    state = {
        countdownActive: true,
        finished: false,
    };

    componentDidMount() {
        const { getWorkoutBreakdown, getWorkout } = this.props;
        const currentWorkoutId = this.props.currentWorkoutId || this.props.match.params.workoutId;

        getWorkoutBreakdown(currentWorkoutId);
        getWorkout(currentWorkoutId);
    }

    stopCountdown = () => {
        this.setState({ countdownActive: false });
    };

    finishWorkout = () => {
        if (this.props.location) {
            const redirectUrl = this.props.location.pathname.split('/');
            redirectUrl.pop();
            window.location.href = redirectUrl.join('/');
        } else {
            this.setState({ finished: true });
        }
    };

    render() {
        const {
            props: { isBreakdownLoading, breakDowns, workoutInfo, workoutOwner, slideIndex },
            state: { countdownActive, finished },
            stopCountdown,
            finishWorkout,
        } = this;

        return (
            <RepeatContainer isEmbed={this.props.isEmbed}>
                {countdownActive && (
                    <CountdownBackground slideIndex={slideIndex + 1}>
                        <Loading isLoading={isBreakdownLoading}>
                            <Countdown onClose={stopCountdown} />
                        </Loading>
                    </CountdownBackground>
                )}
                {!finished &&
                    breakDowns.length > 0 && (
                        // <Loading isLoading={isBreakdownLoading}>
                        <RepeatWorkoutContent
                            slideIndex={slideIndex + 1}
                            finish={finishWorkout}
                            start={!countdownActive}
                            breakDown={breakDowns}
                        />
                        // </Loading>
                    )}

                {finished && (
                    <CountdownBackground isEmbed={this.props.isEmbed} slideIndex={slideIndex + 1}>
                        <Text size={'10vw'} weight={'bold'}>
                            Finished!
                        </Text>
                    </CountdownBackground>
                )}

                <Footer workoutOwner={workoutOwner} workoutInfo={workoutInfo} displayBoardType={false} />
            </RepeatContainer>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getWorkoutBreakdown: workoutId => dispatch(BreakDownActionCreators.getBreakDownByIdRequest(workoutId)),
    getWorkout: workoutId => dispatch(WorkoutActionCreators.getByIdRequest(workoutId)),
});

const mapStateToProps = (
    {
        breakdown: {
            statuses: { isBreakdownLoading },
            breakdowns,
        },
        user: {
            currentUserPreferences: { metric },
        },
        workout: { currentWorkouts },
    },
    props,
) => {
    const workoutId = props.currentWorkoutId || props.match.params.workoutId;
    let workout = {};
    let breakDown = [];

    Object.values(currentWorkouts).forEach(wOut => {
        if (wOut.id == workoutId) workout = { ...wOut };
    });

    Object.keys(breakdowns).forEach(bd => {
        if (bd == workoutId) breakDown = [...breakdowns[bd]];
    });

    return {
        isBreakdownLoading,
        breakDowns: breakDown,
        metric,
        workoutInfo: workout,
        workoutOwner: workout.user,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RepeatWorkout);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Repeat/index.js